export default __webpack_public_path__ + "static/FB分享圖-3246ba5f0d01358ec196db7f55ae2322.png";